"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserQuestionSolid: function() {
        return UserQuestionSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserQuestionSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 1C9.23858 1 7 3.23858 7 6C7 8.76142 9.23858 11 12 11C14.7614 11 17 8.76142 17 6C17 3.23858 14.7614 1 12 1Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H17.1375C17.027 22.6872 16.9668 22.3506 16.9668 22C16.9668 21.5538 17.0642 21.1304 17.2389 20.7498C17.0305 20.2948 16.9419 19.7982 16.9731 19.3079C15.5562 18.7766 14.739 17.2509 15.1247 15.7522C15.3859 14.7375 15.9569 13.8467 16.7316 13.188C15.323 12.4301 13.7117 12 12 12Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M19.9675 16C19.5029 16 19.11 16.3177 18.999 16.7493C18.8613 17.2841 18.3161 17.6061 17.7813 17.4684C17.2464 17.3308 16.9244 16.7856 17.0621 16.2507C17.3951 14.957 18.5683 14 19.9675 14C21.6244 14 22.9675 15.3431 22.9675 17C22.9675 17.9314 22.513 18.5493 22.037 19.0087C21.8442 19.1948 21.6246 19.3768 21.4272 19.5404L21.3414 19.6116C21.111 19.8033 20.8905 19.9913 20.6746 20.2071C20.2841 20.5976 19.6509 20.5976 19.2604 20.2071C18.8699 19.8166 18.8699 19.1834 19.2604 18.7929C19.5446 18.5087 19.8241 18.2723 20.0624 18.074L20.1539 17.998C20.3584 17.8283 20.5137 17.6993 20.6481 17.5697C20.922 17.3053 20.9675 17.1732 20.9675 17C20.9675 16.4477 20.5198 16 19.9675 16Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M18.9668 22C18.9668 21.4477 19.4145 21 19.9668 21H19.9768C20.5291 21 20.9768 21.4477 20.9768 22C20.9768 22.5523 20.5291 23 19.9768 23H19.9668C19.4145 23 18.9668 22.5523 18.9668 22Z",
            fill: "currentColor"
        })
    ]
}), "UserQuestionSolid");
const _default = UserQuestionSolid;
